import React, { useEffect } from "react";
import CustomerSearchInput from "../common/CustomerSearch";

function InfoHeader({
  customers = [],
  selectedCustomer,
  setCustomer,
  serialNumber,
  date,
  setDate,
  time,
  setTime,
}) {
  return (
    <div className="info-row">
      <div>
        <div className="field">
          <label>Serial No</label>
          <input type="text" readOnly value={serialNumber} />
        </div>
      </div>

      <div>
        <div className="field">
          <label>Date</label>
          <input
            type="date"
            value={date}
            onChange={(e) => {
              setDate(e.target.value);
            }}
          />
        </div>
      </div>
      {/* 
      <div>
        <div className="field">
          <label>Party Name</label>

          <select
            className="form-control"
            onChange={(e) =>
              setCustomer(customers.find((c) => c._id === e.target.value))
            }
          >
            <option value="">-- Select Party --</option>

            {customers.map((customer) => (
              <option key={customer._id} value={customer._id}>
                {customer.name} | {customer.phone}
              </option>
            ))}
          </select>
        </div>
      </div> */}

      <div id="filters">
        <div className="field">
          <label>Party Name</label>
          <CustomerSearchInput
            customers={customers}
            placeholder="-- Select Party --"
            value={selectedCustomer}
            onChange={(customer) => setCustomer(customer)}
            inputClass="kw-customer-select" // 👈 keeps your same style
          />
        </div>
      </div>
      <div>
        <div className="field">
          <label>Time</label>
          <input
            type="time"
            value={time}
            onChange={(e) => setTime(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
}

export default InfoHeader;
